import { fetchConToken } from "../helpers/fetch";

export const TotemBasicService = {
    // Solicitudes
    getSolicitudes: () => fetchConToken(`TotemBasic/Solicitudes`),
    insertSolicitud: (data) => fetchConToken(`TotemBasic/Solicitudes`, data, "POST"),
    deleteSolicitud: (data) => fetchConToken(`TotemBasic/Solicitudes`, data, "DELETE"),
    tomarSolicitud: (data) => fetchConToken(`TotemBasic/Solicitudes/Tomar`, data, "PUT"),
    liberarSolicitud: (data) => fetchConToken(`TotemBasic/Solicitudes/Liberar`, data, "PUT"),
    
    // Boxes
    getBoxes: () => fetchConToken(`TotemBasic/Boxes`),
    insertBox: (data) => fetchConToken(`TotemBasic/Boxes`, data, "POST"),
    updateBox: (data) => fetchConToken(`TotemBasic/Boxes`, data, "PUT"),
    deleteBox: (data) => fetchConToken(`TotemBasic/Boxes`, data, "DELETE"),

    // Boxes Tomados
    getBoxesTomados: () => fetchConToken(`TotemBasic/BoxesTomados`),
    tomarBox: (data) => fetchConToken(`TotemBasic/BoxesTomados`, data, "POST"),
    liberarBox: (data) => fetchConToken(`TotemBasic/BoxesTomados`, data, "PUT"),

    // Opciones
    getOpciones: () => fetchConToken(`TotemBasic/Opciones`),
    insertOpcion: (data) => fetchConToken(`TotemBasic/Opciones`, data, "POST"),
    updateOpcion: (data) => fetchConToken(`TotemBasic/Opciones`, data, "PUT"),
    deleteOpcion: (data) => fetchConToken(`TotemBasic/Opciones`, data, "DELETE"),

    // SubOpciones
    getSubOpciones: () => fetchConToken(`TotemBasic/SubOpciones`),
    insertSubOpcion: (data) => fetchConToken(`TotemBasic/SubOpciones`, data, "POST"),
    updateSubOpcion: (data) => fetchConToken(`TotemBasic/SubOpciones`, data, "PUT"),
    deleteSubOpcion: (data) => fetchConToken(`TotemBasic/SubOpciones`, data, "DELETE"),

    // Opciones Por Box
    insertOpcionPorBox: (data) => fetchConToken(`TotemBasic/OpcionesPorBox`, data, "POST"),
};
